import { getTimelineBlockHeight, timeToMinutes, minutesToTime } from '../../lib/timeline';
import type { ColumnLayout } from '../../lib/timeline';

interface CalendarEvent {
  id: string;
  title: string;
  startTime: string;
  endTime: string;
  status?: string;
}

interface PlannerMeetingBlockProps {
  event: CalendarEvent;
  startHour: number;
  pxPerHour: number;
  columnLayout?: ColumnLayout;
}

export function PlannerMeetingBlock({ event, startHour, pxPerHour, columnLayout }: PlannerMeetingBlockProps) {
  const startMinutes = timeToMinutes(event.startTime);
  const endMinutes = timeToMinutes(event.endTime);
  const durationMinutes = endMinutes - startMinutes;

  const top = ((startMinutes - startHour * 60) * pxPerHour) / 60;
  const height = getTimelineBlockHeight(durationMinutes, pxPerHour);
  const isShort = height < 36;

  const cancelled = event.status === 'cancelled';

  const col = columnLayout?.column ?? 0;
  const totalCols = columnLayout?.totalColumns ?? 1;
  const style: React.CSSProperties = {
    top,
    height,
    ...(totalCols > 1 ? {
      left: `${(col / totalCols) * 100}%`,
      width: `${100 / totalCols}%`,
    } : {}),
  };

  return (
    <div
      className={`absolute ${totalCols <= 1 ? 'left-0.5 right-0.5' : ''} rounded-md bg-accent/8 border border-accent/20 overflow-hidden ${
        cancelled ? 'opacity-40' : ''
      }`}
      style={style}
    >
      <div className={`h-full overflow-hidden px-1.5 ${isShort ? 'py-0.5 flex items-center gap-1.5' : 'py-1'}`}>
        <p
          className={`text-[10px] text-text-secondary font-medium truncate ${
            cancelled ? 'line-through' : ''
          }`}
        >
          {event.title}
        </p>
        {!isShort && (
          <p className="text-[9px] text-text-muted font-mono">
            {minutesToTime(startMinutes)} – {minutesToTime(endMinutes)}
          </p>
        )}
      </div>
    </div>
  );
}
